class ScrollService {
    scrollHandler = {
      scrollToHome: () => {
        window.scrollTo({ top: 0, behavior: "smooth" }); // Scroll to the top smoothly
      },
    };
  }
  
  export default new ScrollService();
  